export default __webpack_public_path__ + "static/media/icon-boun-suang.96a416f6.webp";